//#region Libraries
import styled from "styled-components";
//#endregion

export const Report = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 5px;
    list-style: disc !important;
    & li {
        font-size: 17px;
    }
`;